import * as z from "zod";

export const MAX_CLAIM_DOCUMENT_REQUEST_DESCRIPTION_LENGTH = 2000;

export const requestAdditionalClaimDocuments = {
  name: "requestAdditionalClaimDocuments" as const,
  input: z.object({
    returnId: z.string(),
    description: z
      .string()
      .trim()
      .min(1)
      .max(MAX_CLAIM_DOCUMENT_REQUEST_DESCRIPTION_LENGTH),
    /** Overrides the return's customer email as the notification recipient. */
    recipientEmail: z.string().trim().email().optional(),
  }),
  output: z.null(),
};
